@if (options) {
<div class="account-options">
  <div class="account-options__title" data-testid="accountOptionsTitle">Qual conta você quer criar?</div>
  <div class="account-options__subtitle" data-testid="accountOptionsTitleIdentity">
    Você entrou pelo gov.br como {{ options.name }}.
  </div>

  @if (options.joinedCompanies?.length) {
  <div class="account-options__joined" data-testid="accountOptionsMessageJoined">
    <p>
      Você já representa
      @for (company of options.joinedCompanies; track company.cnpj; let last = $last) {
      <strong>{{ company.razaoSocial }}</strong>{{ last ? '' : ', ' }}
      }
      no Aprova. Entre com o gov.br para acessar a conta da empresa.
    </p>
    <button
      type="button"
      class="account-options__joined-login"
      data-testid="accountOptionsButtonLoginJoined"
      (click)="loginWithGovBr()"
    >
      Entrar com gov.br
    </button>
  </div>
  }

  @if (options.companiesUnavailable) {
  <div class="account-options__notice" data-testid="accountOptionsMessageCompaniesUnavailable">
    Não conseguimos consultar agora as empresas vinculadas à sua conta gov.br. Você
    pode cadastrar a empresa informando o CNPJ, ou tentar de novo mais tarde.
  </div>
  } @else if (!options.companies.length) {
  <div class="account-options__notice" data-testid="accountOptionsMessageNoCompanies">
    O gov.br só mostra empresas vinculadas à sua conta com certificado digital e-CNPJ,
    e nenhuma foi encontrada. Você pode vincular a empresa em
    <strong>gov.br › Empresas</strong> com o e-CNPJ ou cadastrar informando o CNPJ.
  </div>
  }

  <div class="account-options__list">
    @if (options.personalAccountAvailable) {
    <button
      type="button"
      class="account-options__item"
      data-testid="accountOptionsRowPersonal"
      [disabled]="creating()"
      (click)="createPersonalAccount()"
    >
      <span class="account-options__picture">PF</span>
      <span class="account-options__details">
        <span class="account-options__name">Conta pessoal</span>
        <span class="account-options__description">{{ options.name }}</span>
        <span class="account-options__type" data-testid="accountOptionsBadgePersonal">Pessoa física</span>
      </span>
    </button>
    }

    @for (company of options.companies; track company.cnpj) {
    <button
      type="button"
      class="account-options__item"
      [attr.data-testid]="'accountOptionsRowCompany-' + company.cnpj"
      [disabled]="creating()"
      (click)="registerCompany(company)"
    >
      <span class="account-options__picture account-options__picture--company">PJ</span>
      <span class="account-options__details">
        <span class="account-options__name">{{ company.razaoSocial }}</span>
        <span class="account-options__description">
          CNPJ {{ company.cnpj | mask: 'AA.AAA.AAA/AAAA-00' }}
        </span>
        <span class="account-options__type" [attr.data-testid]="'accountOptionsBadgeCompany-' + company.cnpj">
          Pessoa jurídica
        </span>
      </span>
    </button>
    }

    <button
      type="button"
      class="account-options__item"
      [class.account-options__item--other]="!companyByCnpjIsTheOnlyOption"
      data-testid="accountOptionsRowOtherCompany"
      [disabled]="creating()"
      (click)="registerOtherCompany()"
    >
      <span class="account-options__picture account-options__picture--company">
        <app-icon name="office-building-solid" color="currentColor" />
      </span>
      <span class="account-options__details">
        @if (companyByCnpjIsTheOnlyOption) {
        <span class="account-options__name">Cadastrar empresa</span>
        <span class="account-options__description">Informe o CNPJ da empresa</span>
        } @else {
        <span class="account-options__name">Outra empresa</span>
        <span class="account-options__description">Cadastrar informando o CNPJ</span>
        }
      </span>
    </button>
  </div>

  <button
    type="button"
    class="account-options__back"
    data-testid="accountOptionsButtonBack"
    (click)="backToLogin()"
  >
    Voltar
  </button>
</div>
}
